import { useCallback } from 'react';
import { message as antMessage } from 'antd';

interface UseErrorHandlerProps {
    setError: React.Dispatch<React.SetStateAction<string | null>>;
}

export const useErrorHandler = ({ setError }: UseErrorHandlerProps) => {
    // 处理错误
    const handleError = useCallback((error: unknown, customMessage?: string) => {
        const errorMessage = error instanceof Error ? error.message : customMessage || '操作失败';
        setError(errorMessage);
        antMessage.error(errorMessage);
        console.error(customMessage || '发生错误:', error);
    }, [setError]);

    // 清除错误
    const clearError = useCallback(() => {
        setError(null);
    }, [setError]);

    // 设置错误
    const setErrorMessage = useCallback((message: string) => {
        setError(message);
        antMessage.error(message);
    }, [setError]);

    return {
        handleError,
        clearError,
        setErrorMessage,
    };
};